export default __webpack_public_path__ + "img/bg_hero-14c25e5cba57c8561b52999232bfc9e5.png";